export const translations = {
  en: {
    aboutUsNav: "What is Rapido Relief?",
    whatWeOffer: "What We Offer",
    explore: "Explore",
    mentalHealth: "Mental Health",
    getInvolved: "Get Involved!",
    globeDropdown: "Select Language",
    ourStory: "Our Story",
    careers: "Careers",
    contactUs: "Contact Us",
    ourProviders: "Our Providers",
    blog: "Blog",
    ourSolutions: "Our Solutions",
    workWithUs: "Work with Us!",
    whatItCost: "What it Cost",
    browseTopSpecialties: "Browse Top Specialties",
    heading: "REVOLUTIONIZING HEALTHCARE ACESS",
    subheading: "ANYTIME, ANYWHERE",
    description: "Rapido Relief connects you with top-rated healthcare professionals for fast, reliable medical support-whether it's for everday care, mental health, or emergencies.",
    subscribeNav: "SUBSCRIBE Now",
    becomeMember: "To become a community member",
    howRapidoWorksTitle: "How Rapido Relief Works",
    simpleButtonText: "It’s very simple",
    card1Title: "Sign Up and Confirm Your Registration",
    card1Description1: "Create an account quickly with your email or social login.",
    card1Description2: "Confirm your registration to get started!",
    card2Title: "Choose a Plan & Access Exclusive Services",
    card2Description1: "Select a subscription that fits your needs and make a secure payment.",
    card2Description2: "Unlock exclusive access to healthcare services, support, and resources.",
    card3Title: "Connect & Start Your Health Journey",
    card3Description1: "Enjoy seamless access to healthcare professionals and a range of support options.",
    card3Description2: "Get the care you need anytime, anywhere!",
    headerText: "See a doctor with or without insurance!",
    searchLabel: "Search",
    searchInputPlaceholder: "Condition, Physician or Pharmacy",
    locationLabel: "Location",
    locationInputPlaceholder: "City, State or Zip/Post Code",
    insuranceLabel: "Have Insurance",
    insuranceInputPlaceholder: "Choose Insurance",
    addIconTooltipText: "Add",
    seeDoctor: "See a doctor with or without insurance!",
    search: "Search",
    searchPlaceholder: "Condition, Physician or Pharmacy",
    location: "Location",
    locationPlaceholder: "City, State or Zip/Post Code",
    haveInsurance: "Have Insurance",
    chooseInsurance: "Choose Insurance",
    consultOnline: "Consult Online",
    findPharmacy: "Find Pharmacy",
    findDoctors: "Find a Doctor",
    findHospital: "Find a Hospital",
    emergencyAmbulance: "Emergency Ambulance",
    mentalHealth: "Mental Health",
    telemedicineConsultations: "Telemedicine Consultations",
    telemedicineDescription: "On-demand teleconsultations with general physicians for preliminary medical advice and non-emergency healthcare concerns.",
    virtualTherapySessions: "Virtual Therapy Sessions",
    virtualTherapyDescription: "Access to virtual mental health sessions with licensed therapists to provide support and guidance in times of need.",
    wearableHealthcare: "Wearable Healthcare",
    wearableHealthcareDescription: "We offer a range of smart medical wearable devices, from fetal heart rate monitors to emergency alert systems.",
    aboutRapidoReliefApp: "About Rapido Relief App",
    rapidoReliefDescription: "Rapido Relief App is revolutionizing emergency healthcare by offering immediate access to qualified professionals through our innovative telehealthcare platform. We prioritize rapid response and efficient care to ensure your peace of mind during emergencies.",
    peaceOfMind: "Experience peace of mind knowing that Rapido Relief App offers immediate access to quality healthcare professionals. From medical advice to urgent care, we ensure swift and efficient connections when you need it the most.",
    allInOne: "All-in-one",
    completeHealthcare: "Complete healthcare",
    fastAndAccurate: "Fast & Accurate",
    testReports: "Test reports",
    customerSupport: "Customer support",
    areYouProvider: "Are you a provider & interested in reaching new patients?",
    listYourPractice: "List your practice on Rapido Relief Marketplace & be discovered.",
    enlistPracticeOrStore: "Enlist your Practice or Store on Rapido Relief App",
    getDoctorWhoGetsYou: "Let’s get you a doctor who gets you",
    telehealthAIChatbot: "Telehealth AI Chatbot",
    rapidosDescription: "With Rapido, patients can schedule virtual consultations with our telehealth chatbot, whether you're seeking routine check-ups, specialist opinions, or mental health support.",
    joinUsJourney: "Join us on this inspiring journey as we harness the potential of AI to redefine healthcare, one innovative solution at a time.",
    rapidoChatbotAppointments: "Rapido Chatbot Booking Appointments",
    telehealthChatbot: "Telehealth Chatbot",
    seeSpecialistsWithInsurance: "See specialists who accept your health insurance on our platform",
    mentalHealthSupport: "Mental Health Support",
    mentalHealthDescription: "Our platform also provides mental health support with licensed therapists available for counseling sessions and emotional support.",
    smartAlertSystem: "SmartAlert System",
    sendEmergencyAlert: "Users can send emergency alerts with a simple press of a button.",
    faqTitle: "FAQ's",
    swiftAccess: "Swift access",
    swiftAccessDescription: "Our telehealthcare platform offers immediate assistance from qualified healthcare professionals, ensuring rapid response in emergency situations.",
    rapidConnections: "Rapid connections",
    rapidConnectionsDescription: "Need urgent help? Our app connects you with healthcare professionals swiftly, ensuring timely assistance in emergencies.",
    quickAssistance: "Quick assistance",
    quickAssistanceDescription: "Our platform facilitates quick connections with healthcare experts, providing swift solutions to medical emergencies.",
    immediateHelp: "Immediate help",
    immediateHelpDescription: "Rapidly access qualified healthcare professionals through our app, receiving immediate help when you need it most.",
    featuredCustomer: "Featured Customers & Partners",
    cutDownTravelTime: "Cut Down On Travel Time",
    zeroWaitingPeriod: "Zero Waiting Period",
    certifiedExperts: "Certified Experts",
    rapidoReliefJobs: "Rapido Relief Jobs",
    joinUsTransformHealthcare: "Join us, and help transform healthcare for everyone",
    viewJobOpenings: "View job openings",
    needSupport: " Are you already a customer and need support?",
    talkWhatsapp: " Talk on WhatsApp",
    esgTrends: "ESG | Latest trends",
    esgInsights: "insights",
    seeAllNews: "See All News",
    esgDate: "Jun 25, 2024",
    authorName: "author name",
    breakingBarriers: " Breaking Barriers: How Rapido AI Transforms Mental Health",
    telehealth: "Telehealth",
    telemedicine: "Telemedicine",
    empoweringPatients: "Empowering Patients: Rapido’s Telehealth Success Stories",
    rapidoAIDriven: " Rapido’s AI-Driven Telehealth: Bridging the Gap Healthcare",
    futureOfTelemedicine: " The Future of Telemedicine: Insights from Experts",
    AI: "AI",
    machineLearning: "Machine Learning",
    yourName: "Enter your name",
    yourEmail: "Enter your email",
    subscribe: "SUBSCRIBE",
    checkBox: "By checking this box, you confirm that you have read and are agreeing to our terms of use regarding the storage of the data submitted through this form.",
    companyName: "RapidoRelief",
  supportText: "For support or any-related inquiries, please write to us at contact@rapidorelief.com",
  followUs: "Follow Us On Social Media",
  solution: "Solution",
  findDoctors: "Find Doctors",
  findPharmacy: "Find Pharmacy",
  healthcareExpertise: "Healthcare Expertise",
  patientCommunication: "Patient Communication",
  providerCollaboration: "Provider Collaboration",
  workflowAutomation: "Workflow Automation",
  resources: "Resources",
  aboutUs: "About Us",
  blog: "Blog",
  successStories: "Success stories",
  whitePapers: "White papers",
  career: "Career / CSR",
  podcastsVideos: "Podcasts / Videos",
  comingSoon: "Coming Soon on",
  getItOn: "GET IT ON",
  googlePlay: "Google Play",
  downloadOnAppStore: "Download on the",
  language: "English - En",
  copyright: "© 2024 © RapidoRelief. All Rights Reserved.",
  privacyPolicy: "Privacy Policy",
  legal: "legal",
  cookies: "cookies",
  termsConditions: "terms & conditions",
  welcome: "Welcome to Rapido Relief! 😊 How can I assist you today? Are you here as a:",
    mental_health: "Patient seeking mental health support",
    healthcare_provider: "Healthcare provider looking for more information",
    emergency_support: "I need emergency support",
    healthcare_services: "I'm looking for healthcare services near me",
    emergency_support_message: "It sounds like you're in an emergency situation. Who would you like to contact?",
    ambulance: "Ambulance",
    doctor: "Doctor",
    family: "Family",
    device_alert: "Activate emergency alert",
    ambulance_message: "Would you like me to notify the nearest ambulance service?",
    yes: "Yes, notify now",
    no: "No, cancel",
    ambulance_confirmed: "An ambulance has been notified. Stay safe!",
    mental_health_message: "Would you like resources for mental health or self-help tools?",
    articles: "Articles & videos",
    coping_strategies: "Coping strategies",
    back: "No, thank you",
    mental_health_articles: "Here are some resources to help you. [Link to articles]",
    coping_strategies_message: "Here are coping strategies: mindfulness, staying active, etc.",
    back_to_menu: "Back to Menu",

    //fundraise page

    heroSectionTitle: "Help build The Future of Instant Medical Care",
    heroSectionDescription:
      "Your support helps connect individuals to life-saving medical care when they need it most. Join us in making healthcare accessible to everyone, everywhere.",
    heroSectionDonateButton: "Donate Now",
    heroSectionSupportButton: "Support by Shopping",
    heroSectionSignupText: "Become a member of our community?",
    heroSectionSignupLinkText: "Sign up",
      helpSectionTitle: "How You Can Help Build Rapido Relief App",
      helpSectionDescription:
        "Building an app that transforms lives requires resources. With your help, we can bring Rapido Relief App to those who need it the most. There are two ways you can support us: by donating or purchasing one of our carefully selected healthy products. Every contribution brings us one step closer to our goal.",
      donateButtonText: "Donate Now",
      shopButtonText: "Shop Now",
      productSectionTitle: "Featured Healthy Affiliate Products",
      productSectionSubtitle: "Shop Our Health & Wellness Products to Support Rapido Relief",
      productSectionDescription:
        "By purchasing any of these products, a percentage of the proceeds will go directly to the development of the Rapido Relief App. Not only will you be supporting our project, but you’ll also be investing in your health and well-being.",
      product1Description:
        "Support your immune system with our trusted organic multivitamin. 10% of proceeds go towards Rapido Relief.",
      product2Description:
        "Track your health and fitness with this sleek wearable. Support our app development while improving your well-being.",
      product3Description:
        "Relax and relieve stress with this calming aromatherapy diffuser. Every purchase helps build the Rapido Relief App.",
      buyNowButton: "Buy Now",
      productAdsFirstProductCategory: "Products Essentials",
      productAdsFirstProductName: "Bottle With Wooden Cork",
      productAdsFirstProductPrice: "$59.25",
      productAdsSecondProductCategory: "Products Furniture",
      productAdsSecondProductName: "Hauteville Plywood Chair",
      productAdsSecondProductPrice: "$59.25",
      buyNowButton: "Buy now",
      trendingProductsTitle: "Trending Products Reviews",
    productSubtitle1: "Branded",
    productDescription1: "Ayurvedic Products",
    productSubtitle2: "Branded",
    productDescription2: "Vitamins & Protein Sup..",
    productSubtitle3: "Branded",
    productDescription3: "Mother & Baby Care",
    productSubtitle4: "Branded",
    productDescription4: "Healthy Foods & Drinks",

  
  
  },
  pt: {
    aboutUsNav: "O que é Rapido Relief?",
    whatWeOffer: "O que oferecemos",
    explore: "Explorar",
    mentalHealth: "Saúde Mental",
    getInvolved: "Envolver-se!",
    globeDropdown: "Escolher Idioma",
    ourStory: "Nossa História",
    careers: "Carreiras",
    contactUs: "Contate-nos",
    ourProviders: "Nossos Provedores",
    blog: "Blog",
    ourSolutions: "Nossas Soluções",
    workWithUs: "Trabalhe Conosco!",
    whatItCost: "Quanto custa",
    browseTopSpecialties: "Navegar pelas Principais Especialidades",
    heading: "Rápido Relief",
    subheading: "Seu portal para melhores soluções",
    description: "Estamos liderando o futuro da saúde com soluções inovadoras de telemedicina.",
    subscribeNav: "Assine agora",
    becomeMember: "Torne-se um membro da comunidade",
    howRapidoWorksTitle: "Como o Rapido Relief Funciona",
    simpleButtonText: "É muito simples",
    card1Title: "Cadastre-se e confirme seu registro",
    card1Description1: "Crie uma conta rapidamente com seu e-mail ou login social.",
    card1Description2: "Confirme seu registro para começar!",
    card2Title: "Escolha um plano e acesse serviços exclusivos",
    card2Description1: "Selecione uma assinatura que atenda às suas necessidades e faça um pagamento seguro.",
    card2Description2: "Desbloqueie acesso exclusivo a serviços de saúde, suporte e recursos.",
    card3Title: "Conecte-se e inicie sua jornada de saúde",
    card3Description1: "Desfrute de acesso contínuo a profissionais de saúde e uma variedade de opções de suporte.",
    card3Description2: "Obtenha os cuidados de que precisa, a qualquer hora, em qualquer lugar!",
    headerText: "Consulte um médico com ou sem seguro!",
    searchLabel: "Pesquisar",
    searchInputPlaceholder: "Condição, Médico ou Farmácia",
    locationLabel: "Localização",
    locationInputPlaceholder: "Cidade, Estado ou Código Postal",
    insuranceLabel: "Tem Seguro",
    insuranceInputPlaceholder: "Escolha o Seguro",
    addIconTooltipText: "Adicionar",
    seeDoctor: "Consulte um médico com ou sem seguro!",
    search: "Pesquisar",
    searchPlaceholder: "Condição, Médico ou Farmácia",
    location: "Localização",
    locationPlaceholder: "Cidade, Estado ou Código Postal",
    haveInsurance: "Tem Seguro",
    chooseInsurance: "Escolha o Seguro",
    consultOnline: "Consultar Online",
    findPharmacy: "Encontrar Farmácia",
    findDoctors: "Encontrar um Médico",
    findHospital: "Encontrar um Hospital",
    emergencyAmbulance: "Ambulância de Emergência",
    mentalHealth: "Saúde Mental",
    telemedicineConsultations: "Consultas de Telemedicina",
    telemedicineDescription: "Consultas de telemedicina sob demanda com médicos gerais para conselhos médicos preliminares e preocupações de saúde não emergenciais.",
    virtualTherapySessions: "Sessões de Terapia Virtual",
    virtualTherapyDescription: "Acesso a sessões virtuais de saúde mental com terapeutas licenciados para fornecer suporte e orientação em momentos de necessidade.",
    wearableHealthcare: "Saúde Usável",
    wearableHealthcareDescription: "Oferecemos uma variedade de dispositivos médicos vestíveis inteligentes, desde monitores de frequência cardíaca fetal até sistemas de alerta de emergência.",
    aboutRapidoReliefApp: "Sobre o Aplicativo Rapido Relief",
    rapidoReliefDescription: "O Rapido Relief App está revolucionando o atendimento de emergência oferecendo acesso imediato a profissionais qualificados por meio de nossa plataforma inovadora de telemedicina. Priorizamos uma resposta rápida e atendimento eficiente para garantir sua tranquilidade durante emergências.",
    peaceOfMind: "Experimente a tranquilidade sabendo que o Rapido Relief App oferece acesso imediato a profissionais de saúde de qualidade. Desde conselhos médicos até atendimento urgente, garantimos conexões rápidas e eficientes quando você mais precisa.",
    allInOne: "Tudo-em-um",
    completeHealthcare: "Saúde completa",
    fastAndAccurate: "Rápido e preciso",
    testReports: "Relatórios de testes",
    customerSupport: "Suporte ao cliente",
    areYouProvider: "Você é um provedor e está interessado em alcançar novos pacientes?",
    listYourPractice: "Liste sua prática no Marketplace Rapido Relief e seja descoberto.",
    enlistPracticeOrStore: "Cadastre sua prática ou loja no aplicativo Rapido Relief",
    getDoctorWhoGetsYou: "Vamos te encontrar um médico que te entende",
    telehealthAIChatbot: "Chatbot de Telessaúde com IA",
    rapidosDescription: "Com o Rapido, os pacientes podem agendar consultas virtuais com nosso chatbot de telessaúde, seja para check-ups de rotina, opiniões de especialistas ou suporte para saúde mental.",
    joinUsJourney: "Junte-se a nós nesta jornada inspiradora enquanto aproveitamos o potencial da IA para redefinir os cuidados de saúde, uma solução inovadora de cada vez.",
    rapidoChatbotAppointments: "Agendamentos com o Chatbot Rapido",
    telehealthChatbot: "Chatbot de Telessaúde",
    seeSpecialistsWithInsurance: "Consulte especialistas que aceitam seu seguro de saúde em nossa plataforma",
    mentalHealthSupport: "Apoio à Saúde Mental",
    mentalHealthDescription: "Nossa plataforma também oferece apoio à saúde mental, com terapeutas licenciados disponíveis para sessões de aconselhamento e apoio emocional.",
    smartAlertSystem: "Sistema SmartAlert",
    sendEmergencyAlert: "Os usuários podem enviar alertas de emergência com um simples pressionar de botão.",
    faqTitle: "FAQ's",
    swiftAccess: "Acesso rápido",
    swiftAccessDescription: "Nossa plataforma de telemedicina oferece assistência imediata de profissionais de saúde qualificados, garantindo uma resposta rápida em situações de emergência.",
    rapidConnections: "Conexões rápidas",
    rapidConnectionsDescription: "Precisa de ajuda urgente? Nosso aplicativo conecta você rapidamente a profissionais de saúde, garantindo assistência pontual em emergências.",
    quickAssistance: "Assistência rápida",
    quickAssistanceDescription: "Nossa plataforma facilita conexões rápidas com especialistas em saúde, proporcionando soluções ágeis para emergências médicas.",
    immediateHelp: "Ajuda imediata",
    immediateHelpDescription: "Acesse rapidamente profissionais de saúde qualificados através do nosso aplicativo, recebendo ajuda imediata quando você mais precisa.",
    featuredCustomer: "Clientes e Parceiros em Destaque",
    cutDownTravelTime: "Reduza o Tempo de Viagem",
    zeroWaitingPeriod: "Nenhum Período de Espera",
    certifiedExperts: "Especialistas Certificados",
    rapidoReliefJobs: "Trabalhos Rapido Relief",
    joinUsTransformHealthcare: "Junte-se a nós e ajude a transformar os cuidados de saúde para todos",
    viewJobOpenings: "Veja as vagas de emprego",
    needSupport: "Você já é um cliente e precisa de suporte?",
  talkWhatsapp: "Fale no WhatsApp",
  esgTrends: "ESG | Últimas tendências",
  esgInsights: "insights",
  seeAllNews: "Ver todas as notícias",
  esgDate: "25 de jun. de 2024",
  authorName: "nome do autor",
  breakingBarriers: "Quebrando Barreiras: Como a IA Rapido Transforma a Saúde Mental",
  telehealth: "Telemedicina",
  telemedicine: "Telemedicina",
  empoweringPatients: "Capacitando Pacientes: Histórias de Sucesso da Telemedicina Rapido",
  rapidoAIDriven: "Telemedicina com IA da Rapido: Fechando a Lacuna na Saúde",
  futureOfTelemedicine: "O Futuro da Telemedicina: Insights de Especialistas",
  AI: "IA",
  machineLearning: "Aprendizado de Máquina",
  yourName: "Digite seu nome",
  yourEmail: "Digite seu e-mail",
  subscribe: "INSCREVER-SE",
  checkBox: "Ao marcar esta caixa, você confirma que leu e concorda com nossos termos de uso em relação ao armazenamento dos dados enviados através deste formulário.",
  companyName: "RapidoRelief",
  supportText: "Para suporte ou qualquer outra dúvida, por favor, escreva para nós em contact@rapidorelief.com",
  followUs: "Siga-nos nas redes sociais",
  solution: "Solução",
  findDoctors: "Encontrar Médicos",
  findPharmacy: "Encontrar Farmácia",
  healthcareExpertise: "Especialização em Saúde",
  patientCommunication: "Comunicação com Pacientes",
  providerCollaboration: "Colaboração com Provedores",
  workflowAutomation: "Automação de Fluxo de Trabalho",
  resources: "Recursos",
  aboutUs: "Sobre Nós",
  blog: "Blog",
  successStories: "Histórias de Sucesso",
  whitePapers: "White Papers",
  career: "Carreiras / RSE",
  podcastsVideos: "Podcasts / Vídeos",
  comingSoon: "Em breve no",
  getItOn: "BAIXE NO",
  googlePlay: "Google Play",
  downloadOnAppStore: "Baixar na",
  language: "Português - Pt",
  copyright: "© 2024 © RapidoRelief. Todos os direitos reservados.",
  privacyPolicy: "Política de Privacidade",
  legal: "legal",
  cookies: "cookies",
  termsConditions: "termos e condições",
  welcome: "Bem-vindo ao Rapido Relief! 😊 Como posso ajudá-lo hoje? Você está aqui como:",
  mental_health: "Paciente buscando suporte para saúde mental",
  healthcare_provider: "Profissional de saúde buscando mais informações",
  emergency_support: "Preciso de apoio de emergência",
  healthcare_services: "Estou procurando serviços de saúde perto de mim",
  emergency_support_message: "Parece que você está em uma situação de emergência. Quem você gostaria de contatar?",
  ambulance: "Ambulância",
  doctor: "Médico",
  family: "Família",
  device_alert: "Ativar alerta de emergência",
  ambulance_message: "Gostaria que eu notificasse o serviço de ambulância mais próximo?",
  yes: "Sim, notificar agora",
  no: "Não, cancelar",
  ambulance_confirmed: "Uma ambulância foi notificada. Fique seguro!",
  mental_health_message: "Gostaria de recursos para saúde mental ou ferramentas de autoajuda?",
  articles: "Artigos e vídeos",
  coping_strategies: "Estratégias de enfrentamento",
  back: "Não, obrigado",
  mental_health_articles: "Aqui estão alguns recursos para ajudá-lo. [Link para artigos]",
  coping_strategies_message: "Aqui estão estratégias de enfrentamento: atenção plena, manter-se ativo, etc.",
  back_to_menu: "Voltar ao Menu",

//fundraise page

heroSectionTitle: "Ajude a construir o futuro do atendimento médico instantâneo",
heroSectionDescription:
  "Seu apoio ajuda a conectar pessoas a cuidados médicos que salvam vidas quando mais precisam. Junte-se a nós para tornar o atendimento médico acessível a todos, em todos os lugares.",
heroSectionDonateButton: "Doe agora",
heroSectionSupportButton: "Apoie comprando",
heroSectionSignupText: "Gostaria de se tornar um membro da nossa comunidade?",
heroSectionSignupLinkText: "Inscreva-se",
helpSectionTitle: "Como Você Pode Ajudar a Construir o Aplicativo Rapido Relief",
helpSectionDescription:
  "Construir um aplicativo que transforma vidas exige recursos. Com a sua ajuda, podemos levar o Aplicativo Rapido Relief para aqueles que mais precisam. Há duas maneiras de nos apoiar: doando ou comprando um dos nossos produtos saudáveis cuidadosamente selecionados. Cada contribuição nos aproxima mais do nosso objetivo.",
donateButtonText: "Doe Agora",
shopButtonText: "Compre Agora",
productSectionTitle: "Produtos Saudáveis em Destaque de Afiliados",
    productSectionSubtitle: "Compre nossos produtos de saúde e bem-estar para apoiar o Rapido Relief",
    productSectionDescription:
      "Ao comprar qualquer um desses produtos, uma porcentagem da receita será destinada diretamente ao desenvolvimento do aplicativo Rapido Relief. Você não estará apenas apoiando nosso projeto, mas também investindo em sua saúde e bem-estar.",
    product1Description:
      "Apoie seu sistema imunológico com nosso multivitamínico orgânico confiável. 10% dos lucros vão para o Rapido Relief.",
    product2Description:
      "Acompanhe sua saúde e forma física com este elegante dispositivo vestível. Apoie o desenvolvimento do nosso aplicativo enquanto melhora seu bem-estar.",
    product3Description:
      "Relaxe e alivie o estresse com este difusor de aromaterapia calmante. Cada compra ajuda a construir o aplicativo Rapido Relief.",
    buyNowButton: "Comprar Agora",
    productAdsFirstProductCategory: "Produtos Essenciais",
    productAdsFirstProductName: "Garrafas com rolha de madeira",
    productAdsFirstProductPrice: "$59.25",
    productAdsSecondProductCategory: "Móveis de Produtos",
    productAdsSecondProductName: "Cadeira de contraplacado Hauteville",
    productAdsSecondProductPrice: "$59.25",
    buyNowButton: "Comprar agora",
    trendingProductsTitle: "Avaliações de Produtos em Alta",
    productSubtitle1: "De Marca",
    productDescription1: "Produtos Ayurvédicos",
    productSubtitle2: "De Marca",
    productDescription2: "Vitaminas e Sup..",
    productSubtitle3: "De Marca",
    productDescription3: "Cuidados para Mães e Bebês",
    productSubtitle4: "De Marca",
    productDescription4: "Comidas e Bebidas Saudáveis",


  },
  
  es:{
    aboutUsNav: "¿Qué es Rapido Relief",
    whatWeOffer: "Qué Ofrecemos",
    explore: "Explorar",
    mentalHealth: "Salud Mental",
    getInvolved: "¡Involúcrate!",
    globeDropdown: "Seleccionar Idioma",
    ourStory: "Nuestra Historia",
    careers: "Carreras",
    contactUs: "Contáctenos",
    ourProviders: "Nuestros Proveedores",
    blog: "Blog",
    ourSolutions: "Nuestras Soluciones",
    workWithUs: "¡Trabaja con Nosotros!",
    whatItCost: "Lo Que Cuesta",
    browseTopSpecialties: "Explorar Principales Especialidades",
    heading: "Rápido Relief",
    subheading: "Atención Médica Revolucionaria para el Siglo XXI",
    description: "Estamos revolucionando el futuro de la salud con soluciones innovadoras de telemedicina.",
    subscribeNav: "SUSCRÍBETE Ahora",
    becomeMember: "Para convertirte en miembro de la comunidad",
    howRapidoWorksTitle: "Cómo Funciona Rápido Relief",
    simpleButtonText: "Es muy simple",
    card1Title: "Regístrate y Confirma tu Registro",
    card1Description1: "Crea una cuenta rápidamente con tu correo electrónico o redes sociales.",
    card1Description2: "¡Confirma tu registro para comenzar!",
    card2Title: "Elige un Plan y Accede a Servicios Exclusivos",
    card2Description1: "Selecciona una suscripción que se adapte a tus necesidades y realiza un pago seguro.",
    card2Description2: "Desbloquea acceso exclusivo a servicios de salud, soporte y recursos.",
    card3Title: "Conéctate y Comienza tu Viaje de Salud",
    card3Description1: "Disfruta de acceso sin interrupciones a profesionales de la salud y una gama de opciones de soporte.",
    card3Description2: "¡Obtén el cuidado que necesitas en cualquier momento y lugar!",
    headerText: "¡Consulta a un médico con o sin seguro!",
    searchLabel: "Buscar",
    searchInputPlaceholder: "Condición, Médico o Farmacia",
    locationLabel: "Ubicación",
    locationInputPlaceholder: "Ciudad, Estado o Código Postal",
    insuranceLabel: "¿Tienes Seguro?",
    insuranceInputPlaceholder: "Elegir Seguro",
    addIconTooltipText: "Añadir",
    seeDoctor: "¡Consulta a un médico con o sin seguro!",
    search: "Buscar",
    searchPlaceholder: "Condición, Médico o Farmacia",
    location: "Ubicación",
    locationPlaceholder: "Ciudad, Estado o Código Postal",
    haveInsurance: "¿Tienes Seguro?",
    chooseInsurance: "Elegir Seguro",
    consultOnline: "Consultar en Línea",
    findPharmacy: "Encontrar Farmacia",
    findDoctors: "Encontrar Médico",
    findHospital: "Encontrar Hospital",
    emergencyAmbulance: "Ambulancia de Emergencia",
    mentalHealth: "Salud Mental",
    telemedicineConsultations: "Consultas de Telemedicina",
    telemedicineDescription: "Teleconsultas a demanda con médicos generales para asesoramiento médico preliminar y problemas de salud no urgentes.",
    virtualTherapySessions: "Sesiones de Terapia Virtual",
    virtualTherapyDescription: "Acceso a sesiones virtuales de salud mental con terapeutas con licencia para brindar apoyo y orientación en momentos de necesidad.",
    wearableHealthcare: "Cuidado Médico Usable",
    wearableHealthcareDescription: "Ofrecemos una gama de dispositivos médicos inteligentes, desde monitores de ritmo cardíaco fetal hasta sistemas de alerta de emergencia.",
    aboutRapidoReliefApp: "Acerca de la App Rápido Relief",
    rapidoReliefDescription: "La App Rápido Relief está revolucionando la atención médica de emergencia al ofrecer acceso inmediato a profesionales calificados a través de nuestra innovadora plataforma de telemedicina. Priorizamos la respuesta rápida y la atención eficiente para garantizar tu tranquilidad en emergencias.",
    peaceOfMind: "Disfruta de la tranquilidad sabiendo que Rápido Relief ofrece acceso inmediato a profesionales de la salud calificados. Desde asesoramiento médico hasta atención urgente, aseguramos conexiones rápidas y eficientes cuando más las necesitas.",
    allInOne: "Todo en uno",
    completeHealthcare: "Atención médica completa",
    fastAndAccurate: "Rápido y Preciso",
    testReports: "Informes de Pruebas",
    customerSupport: "Soporte al Cliente",
    areYouProvider: "¿Eres un proveedor y estás interesado en llegar a nuevos pacientes?",
    listYourPractice: "Registra tu práctica en el Mercado de Rápido Relief y sé descubierto.",
    enlistPracticeOrStore: "Registra tu Práctica o Tienda en la App Rápido Relief",
    getDoctorWhoGetsYou: "Encuentra un médico que te entienda",
    telehealthAIChatbot: "Chatbot de Telemedicina con IA",
    rapidosDescription: "Con Rápido, los pacientes pueden programar consultas virtuales con nuestro chatbot de telemedicina, ya sea para chequeos de rutina, opiniones de especialistas o soporte de salud mental.",
    joinUsJourney: "Únete a este viaje inspirador mientras aprovechamos el potencial de la IA para redefinir la atención médica, una solución innovadora a la vez.",
    rapidoChatbotAppointments: "Citas de Chatbot Rápido",
    telehealthChatbot: "Chatbot de Telemedicina",
    seeSpecialistsWithInsurance: "Consulta especialistas que acepten tu seguro de salud en nuestra plataforma",
    mentalHealthSupport: "Apoyo para la Salud Mental",
    mentalHealthDescription: "Nuestra plataforma también ofrece apoyo de salud mental con terapeutas con licencia disponibles para sesiones de asesoramiento y apoyo emocional.",
    smartAlertSystem: "Sistema SmartAlert",
    sendEmergencyAlert: "Los usuarios pueden enviar alertas de emergencia con solo presionar un botón.",
    faqTitle: "Preguntas Frecuentes",
    swiftAccess: "Acceso rápido",
    swiftAccessDescription: "Nuestra plataforma de telemedicina ofrece asistencia inmediata de profesionales de la salud calificados, asegurando una respuesta rápida en situaciones de emergencia.",
    rapidConnections: "Conexiones rápidas",
    rapidConnectionsDescription: "¿Necesitas ayuda urgente? Nuestra app te conecta rápidamente con profesionales de la salud, asegurando asistencia oportuna en emergencias.",
    quickAssistance: "Asistencia rápida",
    quickAssistanceDescription: "Nuestra plataforma facilita conexiones rápidas con expertos en salud, brindando soluciones rápidas a emergencias médicas.",
    immediateHelp: "Ayuda inmediata",
    immediateHelpDescription: "Accede rápidamente a profesionales de la salud calificados a través de nuestra app, recibiendo ayuda inmediata cuando más lo necesites.",
    featuredCustomer: "Clientes y Socios Destacados",
    cutDownTravelTime: "Reduce el Tiempo de Viaje",
    zeroWaitingPeriod: "Cero Período de Espera",
    certifiedExperts: "Expertos Certificados",
    rapidoReliefJobs: "Trabajos en Rápido Relief",
    joinUsTransformHealthcare: "Únete a nosotros y ayuda a transformar la atención médica para todos",
    viewJobOpenings: "Ver Ofertas de Trabajo",
    needSupport: "¿Eres ya cliente y necesitas ayuda?",
    talkWhatsapp: "Hablar por WhatsApp",
    esgTrends: "ESG | Últimas Tendencias",
    esgInsights: "Perspectivas",
    seeAllNews: "Ver Todas las Noticias",
    esgDate: "Jun 25, 2024",
    authorName: "nombre del autor",
    breakingBarriers: "Rompiendo Barreras: Cómo Rápido AI Transforma la Salud Mental",
    telehealth: "Telemedicina",
    telemedicine: "Telemedicina",
    empoweringPatients: "Empoderando a los Pacientes: Historias de Éxito de Telemedicina de Rápido",
    rapidoAIDriven: "Telemedicina Impulsada por IA de Rápido: Cerrando la Brecha en Salud",
    futureOfTelemedicine: "El Futuro de la Telemedicina: Perspectivas de los Expertos",
    AI: "IA",
    machineLearning: "Aprendizaje Automático",
    yourName: "Ingresa tu nombre",
    yourEmail: "Ingresa tu correo electrónico",
    subscribe: "SUSCRÍBETE",
    checkBox: "Al marcar esta casilla, confirmas que has leído y aceptas nuestros términos de uso sobre el almacenamiento de los datos enviados a través de este formulario.",
    companyName: "RápidoRelief",
    supportText: "Para soporte o cualquier consulta relacionada, escríbenos a contact@rapidorelief.com",
    followUs: "Síguenos en Redes Sociales",
    solution: "Solución",
    findDoctors: "Encontrar Médicos",
    findPharmacy: "Encontrar Farmacia",
    healthcareExpertise: "Expertise en Salud",
    patientCommunication: "Comunicación con Pacientes",
    providerCollaboration: "Colaboración con Proveedores",
    workflowAutomation: "Automatización de Flujos de Trabajo",
    resources: "Recursos",
    blog: "Blog",
    successStories: "Historias de Éxito",
    whitePapers: "Documentos Técnicos",
    career: "Carrera / RSE",
    podcastsVideos: "Podcasts / Videos",
    comingSoon: "Próximamente en",
    getItOn: "DESCARGA EN",
    googlePlay: "Google Play",
    downloadOnAppStore: "Descargar en el",
    language: "Español - Es",
    copyright: "© 2024 © RápidoRelief. Todos los Derechos Reservados.",
    privacyPolicy: "Política de Privacidad",
    legal: "Legal",
    cookies: "Cookies",
    termsConditions: "Términos y Condiciones",
    welcome: "¡Bienvenido a Rápido Relief! 😊 ¿Cómo puedo ayudarte hoy? ¿Estás aquí como:",
    mental_health: "Paciente buscando apoyo para la salud mental",
    healthcare_provider: "Proveedor de atención médica buscando más información",
    emergency_support: "Necesito apoyo de emergencia",
    healthcare_services: "Estoy buscando servicios de salud cerca de mí",
    emergency_support_message: "Parece que estás en una situación de emergencia. ¿A quién te gustaría contactar?",
    ambulance: "Ambulancia",
    doctor: "Doctor",
    family: "Familia",
    device_alert: "Activar alerta de emergencia",
    ambulance_message: "¿Te gustaría que notifique al servicio de ambulancia más cercano?",
    yes: "Sí, notificar ahora",
    no: "No, cancelar",
    ambulance_confirmed: "Se ha notificado una ambulancia. ¡Mantente seguro!",
    mental_health_message: "¿Te gustaría recursos para salud mental o herramientas de autoayuda?",
    articles: "Artículos y videos",
    coping_strategies: "Estrategias de afrontamiento",
    back: "No, gracias",
    mental_health_articles: "Aquí tienes algunos recursos para ayudarte. [Enlace a artículos]",
    coping_strategies_message: "Aquí tienes estrategias de afrontamiento: atención plena, mantenerse activo, etc.",
    back_to_menu: "Volver al Menú",

    //fundraise page

    heroSectionTitle: "Ayuda a construir el futuro de la atención médica instantánea",
heroSectionDescription:
  "Tu apoyo ayuda a conectar a las personas con atención médica que salva vidas cuando más lo necesitan. Únete a nosotros para hacer que la atención médica sea accesible para todos, en todas partes.",
heroSectionDonateButton: "Donar ahora",
heroSectionSupportButton: "Apoya comprando",
heroSectionSignupText: "¿Quieres ser miembro de nuestra comunidad?",
heroSectionSignupLinkText: "Regístrate",
helpSectionTitle: "Cómo Puedes Ayudar a Construir la App Rapido Relief",
helpSectionDescription:
  "Crear una aplicación que transforma vidas requiere recursos. Con tu ayuda, podemos llevar la App Rapido Relief a quienes más lo necesitan. Hay dos maneras en las que puedes apoyarnos: donando o comprando uno de nuestros productos saludables cuidadosamente seleccionados. Cada contribución nos acerca un paso más a nuestro objetivo.",
donateButtonText: "Donar Ahora",
shopButtonText: "Comprar Ahora",
productSectionTitle: "Productos Destacados de Afiliados Saludables",
    productSectionSubtitle: "Compra nuestros productos de salud y bienestar para apoyar Rapido Relief",
    productSectionDescription:
      "Al comprar cualquiera de estos productos, un porcentaje de los ingresos se destinará directamente al desarrollo de la aplicación Rapido Relief. No solo estarás apoyando nuestro proyecto, sino que también invertirás en tu salud y bienestar.",
    product1Description:
      "Apoya tu sistema inmunológico con nuestro multivitamínico orgánico de confianza. El 10% de las ganancias se destina a Rapido Relief.",
    product2Description:
      "Sigue tu salud y estado físico con este elegante dispositivo portátil. Apoya el desarrollo de nuestra app mientras mejoras tu bienestar.",
    product3Description:
      "Relájate y alivia el estrés con este difusor de aromaterapia relajante. Cada compra ayuda a construir la aplicación Rapido Relief.",
    buyNowButton: "Comprar Ahora",
    productAdsFirstProductCategory: "Productos Esenciales",
    productAdsFirstProductName: "Botella con tapón de madera",
    productAdsFirstProductPrice: "$59.25",
    productAdsSecondProductCategory: "Muebles de Productos",
    productAdsSecondProductName: "Silla de contrachapado Hauteville",
    productAdsSecondProductPrice: "$59.25",
    buyNowButton: "Comprar ahora",
    trendingProductsTitle: "Reseñas de Productos de Tendencia",
    productSubtitle1: "De Marca",
    productDescription1: "Productos Ayurvédicos",
    productSubtitle2: "De Marca",
    productDescription2: "Vitaminas y Sup..",
    productSubtitle3: "De Marca",
    productDescription3: "Cuidado de Madre y Bebé",
    productSubtitle4: "De Marca",
    productDescription4: "Comidas y Bebidas Saludables",


  },
  nl: {
    aboutUsNav: "Wat is Rapido Relief?",
    whatWeOffer: "Wat wij aanbieden",
    explore: "Verkennen",
    mentalHealth: "Mentale Gezondheid",
    getInvolved: "Betrokken raken!",
    globeDropdown: "Taal kiezen",
    ourStory: "Ons Verhaal",
    careers: "Carrières",
    contactUs: "Contacteer ons",
    ourProviders: "Onze Leveranciers",
    blog: "Blog",
    ourSolutions: "Onze Oplossingen",
    workWithUs: "Werk met ons!",
    whatItCost: "Wat het kost",
    browseTopSpecialties: "Blader door Top Specialiteiten",
    heading: "Rápido Relief",
    subheading: "Uw toegangspoort tot betere oplossingen",
    description: "Wij zijn de toekomst van gezondheidszorg aan het vormgeven met innovatieve telemedicijnoplossingen.",
    subscribeNav: "Nu abonneren",
    becomeMember: "Word lid van de gemeenschap",
    howRapidoWorksTitle: "Hoe Rapido Relief werkt",
    simpleButtonText: "Het is heel eenvoudig",
    card1Title: "Meld je aan en bevestig je registratie",
    card1Description1: "Maak snel een account aan met je e-mail of social login.",
    card1Description2: "Bevestig je registratie om aan de slag te gaan!",
    card2Title: "Kies een plan en krijg toegang tot exclusieve diensten",
    card2Description1: "Selecteer een abonnement dat bij je behoeften past en doe een veilige betaling.",
    card2Description2: "Ontgrendel exclusieve toegang tot gezondheidsdiensten, ondersteuning en bronnen.",
    card3Title: "Verbinden en start je gezondheidsreis",
    card3Description1: "Geniet van naadloze toegang tot zorgprofessionals en een breed scala aan ondersteuningsopties.",
    card3Description2: "Krijg de zorg die je nodig hebt, altijd en overal!",
    headerText: "Zie een dokter met of zonder verzekering!",
    searchLabel: "Zoeken",
    searchInputPlaceholder: "Aandoening, arts of apotheek",
    locationLabel: "Locatie",
    locationInputPlaceholder: "Stad, Staat of Postcode",
    insuranceLabel: "Verzekering hebben",
    insuranceInputPlaceholder: "Kies Verzekering",
    addIconTooltipText: "Toevoegen",
    seeDoctor: "Zie een arts met of zonder verzekering!",
    search: "Zoeken",
    searchPlaceholder: "Aandoening, arts of apotheek",
    location: "Locatie",
    locationPlaceholder: "Stad, Staat of Postcode",
    haveInsurance: "Verzekering hebben",
    chooseInsurance: "Kies Verzekering",
    consultOnline: "Online Consult",
    findPharmacy: "Apotheek vinden",
    findDoctors: "Arts vinden",
    findHospital: "Ziekenhuis vinden",
    emergencyAmbulance: "Noodambulance",
    mentalHealth: "Mentale Gezondheid",
    telemedicineConsultations: "Telemedicine Consultaties",
    telemedicineDescription: "Teleconsultaties op aanvraag met huisartsen voor voorlopige medische advies en niet-noodgevallen gezondheidskwesties.",
    virtualTherapySessions: "Virtuele Therapie Sessies",
    virtualTherapyDescription: "Toegang tot virtuele mentale gezondheidsessies met gecertificeerde therapeuten voor ondersteuning en begeleiding in tijden van behoefte.",
    wearableHealthcare: "Draagbare Gezondheidszorg",
    wearableHealthcareDescription: "We bieden een reeks slimme medische draagbare apparaten aan, van foetale hartslagmonitors tot noodwaarschuwingssystemen.",
    aboutRapidoReliefApp: "Over de Rapido Relief App",
    rapidoReliefDescription: "De Rapido Relief App revolutioneert spoedeisende zorg door direct toegang te bieden tot gekwalificeerde professionals via ons innovatieve telezorgplatform. We geven prioriteit aan snelle reacties en efficiënte zorg om uw gemoedsrust te waarborgen in noodgevallen.",
    peaceOfMind: "Ervaar gemoedsrust, wetende dat de Rapido Relief App directe toegang biedt tot gekwalificeerde zorgprofessionals. Van medisch advies tot urgente zorg, we zorgen voor snelle en efficiënte verbindingen wanneer u ze het meest nodig heeft.",
    allInOne: "Alles-in-één",
    completeHealthcare: "Complete gezondheidszorg",
    fastAndAccurate: "Snel en nauwkeurig",
    testReports: "Testverslagen",
    customerSupport: "Klantenservice",
    areYouProvider: "Bent u een zorgverlener en geïnteresseerd in het bereiken van nieuwe patiënten?",
    listYourPractice: "Lijst uw praktijk op de Rapido Relief Marketplace en wordt ontdekt.",
    enlistPracticeOrStore: "Meld uw praktijk of winkel aan in de Rapido Relief App",
    getDoctorWhoGetsYou: "Laten we je een dokter vinden die jou begrijpt",
    telehealthAIChatbot: "Telezorg AI Chatbot",
    rapidosDescription: "Met Rapido kunnen patiënten virtuele consultaties plannen met onze telezorg-chatbot, of je nu routinecontroles, specialistische adviezen of ondersteuning voor mentale gezondheid zoekt.",
    joinUsJourney: "Sluit je aan bij ons op deze inspirerende reis terwijl we het potentieel van AI benutten om de gezondheidszorg opnieuw te definiëren, één innovatieve oplossing tegelijk.",
    rapidoChatbotAppointments: "Rapido Chatbot Afspraak Boeken",
    telehealthChatbot: "Telezorg Chatbot",
    seeSpecialistsWithInsurance: "Zie specialisten die je ziektekostenverzekering accepteren op ons platform",
    mentalHealthSupport: "Mentale Gezondheidszorg",
    mentalHealthDescription: "Ons platform biedt ook ondersteuning voor mentale gezondheid, met gecertificeerde therapeuten die beschikbaar zijn voor counseling en emotionele ondersteuning.",
    smartAlertSystem: "SmartAlert Systeem",
    sendEmergencyAlert: "Gebruikers kunnen noodwaarschuwingen verzenden met een simpele druk op de knop.",
    faqTitle: "FAQ's",
    swiftAccess: "Snelle toegang",
    swiftAccessDescription: "Ons telezorgplatform biedt onmiddellijke hulp van gekwalificeerde zorgprofessionals, wat zorgt voor een snelle reactie in noodsituaties.",
    rapidConnections: "Snelle verbindingen",
    rapidConnectionsDescription: "Dringend hulp nodig? Onze app verbindt je snel met zorgprofessionals en biedt tijdige hulp in noodgevallen.",
    quickAssistance: "Snelle hulp",
    quickAssistanceDescription: "Ons platform vergemakkelijkt snelle verbindingen met gezondheidsexperts en biedt snelle oplossingen voor medische noodgevallen.",
    immediateHelp: "Directe hulp",
    immediateHelpDescription: "Krijg snel toegang tot gekwalificeerde zorgprofessionals via onze app en ontvang onmiddellijke hulp wanneer je die het meest nodig hebt.",
    featuredCustomer: "Uitgelichte Klanten & Partners",
    cutDownTravelTime: "Reistijd Vermijden",
    zeroWaitingPeriod: "Geen Wachtperiode",
    certifiedExperts: "Gecertificeerde Experts",
    rapidoReliefJobs: "Rapido Relief Jobs",
    joinUsTransformHealthcare: "Sluit je bij ons aan en help de gezondheidszorg voor iedereen te transformeren",
    viewJobOpenings: "Bekijk vacatures",
    needSupport: "Bent u al klant en heeft u ondersteuning nodig?",
  talkWhatsapp: "Praat op WhatsApp",
  esgTrends: "ESG | Laatste trends",
  esgInsights: "inzichten",
  seeAllNews: "Bekijk alle nieuws",
  esgDate: "25 juni 2024",
  authorName: "naam van de auteur",
  breakingBarriers: "Barrières doorbreken: Hoe Rapido AI de geestelijke gezondheid transformeert",
  telehealth: "Telemedicine",
  telemedicine: "Telemedicine",
  empoweringPatients: "Patiënten versterken: Het succes van Rapido's Telemedicine",
  rapidoAIDriven: "Rapido’s AI-gedreven Telemedicine: De kloof in de gezondheidszorg overbruggen",
  futureOfTelemedicine: "De toekomst van Telemedicine: Inzichten van experts",
  AI: "AI",
  machineLearning: "Machine Learning",
  yourName: "Voer uw naam in",
  yourEmail: "Voer uw e-mailadres in",
  subscribe: "ABONNEREN",
  checkBox: "Door dit vakje aan te vinken, bevestigt u dat u onze gebruiksvoorwaarden met betrekking tot de opslag van de gegevens die via dit formulier zijn ingediend, hebt gelezen en ermee akkoord gaat.",
  companyName: "RapidoRelief",
  supportText: "Voor ondersteuning of andere vragen kunt u ons bereiken via contact@rapidorelief.com",
  followUs: "Volg ons op sociale media",
  solution: "Oplossing",
  findDoctors: "Vind Artsen",
  findPharmacy: "Vind Apotheek",
  healthcareExpertise: "Zorgexpertise",
  patientCommunication: "Patiëntencommunicatie",
  providerCollaboration: "Samenwerking met Zorgverleners",
  workflowAutomation: "Workflowautomatisering",
  resources: "Hulpmiddelen",
  aboutUs: "Over Ons",
  blog: "Blog",
  successStories: "Succesverhalen",
  whitePapers: "White Papers",
  career: "Carrières / MVO",
  podcastsVideos: "Podcasts / Video's",
  comingSoon: "Binnenkort op",
  getItOn: "KRIJG HET OP",
  googlePlay: "Google Play",
  downloadOnAppStore: "Downloaden op de",
  language: "Nederlands - Nl",
  copyright: "© 2024 © RapidoRelief. Alle rechten voorbehouden.",
  privacyPolicy: "Privacybeleid",
  legal: "Juridisch",
  cookies: "Cookies",
  termsConditions: "Algemene Voorwaarden",
  welcome: "Welkom bij Rapido Relief! 😊 Hoe kan ik u vandaag helpen? Bent u hier als:",
  mental_health: "Patiënt op zoek naar ondersteuning voor mentale gezondheid",
  healthcare_provider: "Zorgverlener op zoek naar meer informatie",
  emergency_support: "Ik heb noodhulp nodig",
  healthcare_services: "Ik ben op zoek naar gezondheidsdiensten bij mij in de buurt",
  emergency_support_message: "Het lijkt erop dat u zich in een noodsituatie bevindt. Wie wilt u contacteren?",
  ambulance: "Ambulance",
  doctor: "Dokter",
  family: "Familie",
  device_alert: "Noodalarm activeren",
  ambulance_message: "Wilt u dat ik de dichtstbijzijnde ambulancedienst op de hoogte breng?",
  yes: "Ja, nu op de hoogte stellen",
  no: "Nee, annuleren",
  ambulance_confirmed: "Een ambulance is op de hoogte gesteld. Blijf veilig!",
  mental_health_message: "Wilt u bronnen voor mentale gezondheid of zelfhulpmiddelen?",
  articles: "Artikelen en video's",
  coping_strategies: "Omgangsstrategieën",
  back: "Nee, bedankt",
  mental_health_articles: "Hier zijn enkele bronnen om u te helpen. [Link naar artikelen]",
  coping_strategies_message: "Hier zijn omgangsstrategieën: mindfulness, actief blijven, enz.",
  back_to_menu: "Terug naar Menu",

  // fundraise page

  heroSectionTitle: "Help mee de toekomst van directe medische zorg op te bouwen",
heroSectionDescription:
  "Jouw steun helpt om mensen te verbinden met levensreddende medische zorg wanneer ze het het meest nodig hebben. Doe mee om gezondheidszorg overal toegankelijk te maken voor iedereen.",
heroSectionDonateButton: "Doneer nu",
heroSectionSupportButton: "Ondersteun door te winkelen",
heroSectionSignupText: "Word lid van onze gemeenschap?",
heroSectionSignupLinkText: "Aanmelden",
helpSectionTitle: "Hoe Jij Kunt Helpen bij het Bouwen van de Rapido Relief App",
helpSectionDescription:
  "Het bouwen van een app die levens transformeert, vereist middelen. Met jouw hulp kunnen we de Rapido Relief App brengen naar degenen die het het meeste nodig hebben. Er zijn twee manieren waarop je ons kunt steunen: door te doneren of door een van onze zorgvuldig geselecteerde gezonde producten aan te schaffen. Elke bijdrage brengt ons een stap dichter bij ons doel.",
donateButtonText: "Doneer Nu",
shopButtonText: "Koop Nu",
productSectionTitle: "Uitgelichte Gezonde Affiliate Producten",
productSectionSubtitle: "Koop Onze Gezondheid- en Wellnessproducten ter Ondersteuning van Rapido Relief",
productSectionDescription:
  "Door een van deze producten te kopen, gaat een percentage van de opbrengst rechtstreeks naar de ontwikkeling van de Rapido Relief App. Je ondersteunt niet alleen ons project, maar investeert ook in je gezondheid en welzijn.",
product1Description:
  "Ondersteun je immuunsysteem met onze vertrouwde biologische multivitamine. 10% van de opbrengst gaat naar Rapido Relief.",
product2Description:
  "Volg je gezondheid en fitness met deze stijlvolle wearable. Ondersteun de ontwikkeling van onze app terwijl je je welzijn verbetert.",
product3Description:
  "Ontspan en verlicht stress met deze kalmerende aromatherapie-diffuser. Elke aankoop helpt de Rapido Relief App te bouwen.",
buyNowButton: "Koop Nu",
productAdsFirstProductCategory: "Producten Essentiëlen",
    productAdsFirstProductName: "Fles met houten kurk",
    productAdsFirstProductPrice: "$59.25",
    productAdsSecondProductCategory: "Meubels Producten",
    productAdsSecondProductName: "Hauteville Plywood Stoel",
    productAdsSecondProductPrice: "$59.25",
    buyNowButton: "Koop nu",
    trendingProductsTitle: "Trending Product Beoordelingen",
    productSubtitle1: "Merk",
    productDescription1: "Ayurvedische Producten",
    productSubtitle2: "Merk",
    productDescription2: "Vitaminen & Eiw..",
    productSubtitle3: "Merk",
    productDescription3: "Moeder- en Babyverzorging",
    productSubtitle4: "Merk",
    productDescription4: "Gezonde Voeding & Dranken",
  


}


  
};